export default __webpack_public_path__ + "static/discord-1b070267d69957b666b1640d3ae9876d.png";